module.exports = __webpack_public_path__ + "assets/img/front.55d06533.png";